import type { TokenStorage } from "../auth.type";

const AUTH_TOKEN_KEY = "auth-token";

const createTokenStorage = (key: string): TokenStorage => ({
  get: () => localStorage.getItem(key),
  set: token => localStorage.setItem(key, token),
  clear: () => localStorage.removeItem(key),
});

const authTokenStorage = createTokenStorage(AUTH_TOKEN_KEY);

export { AUTH_TOKEN_KEY, authTokenStorage, createTokenStorage };
